<div
  id="compact-fix-tab-style"
  class="detail-wrapper flex-col"
  [class.sidebar]="pageType === 'sidebar'"
  [class.modal]="pageType === 'modal'">
  <div class="flex-1 pt-[30px]" *ngIf="!pageInitialized; else initialized">
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
  </div>

  <ng-template #initialized>
    <div class="-ml-[30px] pl-[30px] pr-[20px] flex-1 overflow-y-auto overflow-x-hidden">
      <!-- 房源卡片 -->
      <host-widget-house-card [orderDetail]="orderDetail" (onUpdate)="refreshModal.emit(true)"></host-widget-house-card>
      <!-- region 待重构 遗留代码，逻辑有些混乱 todo：重构 -->

      <div
        *ngIf="
          !orderDetail?.is_hour_reservation &&
          !orderDetail?.in_box &&
          statusMap?.['1'] &&
          hasHouseStatus.includes(orderDetail?.out_status)
        ">
        <div class="house-open">
          <div class="open-title">
            <!-- 房态未关： -->
            {{ "order.house_type_not_closed" | translate }}&nbsp;
          </div>
          <div class="closed" [style.width]="'310px'">
            <div *ngFor="let status of statusMap?.['1']">
              <div class="open-thirdtype">
                <span>
                  {{ "word.channel_" + status.thirdparty_type | translate }}
                </span>
                &nbsp;&nbsp;
              </div>
            </div>
            <div class="close-house" (click)="onCloseRoomStatus()" *ngIf="orderDetail?.out_status !== 'completed'">
              <!-- 关闭房态 -->
              {{ "order.close_house_type" | translate }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="orderDetail?.has_no_house">
        <div class="name">
          <!-- 房型 {{ orderDetail?.house_type_title }} 无法排房 -->
          {{ "order.house_type_contains_no_houses" | translate: { houseType: orderDetail?.house_type_title } }}
        </div>
        <div class="error-message" *ngIf="orderDetail?.out_status !== 'cancelled'">
          <!-- 房型下未包含房间，无法排房，请添加房间或移动订单 -->
          {{ "order.type_contains_no_house_info" | translate }}
          <a href="javascript:void(0)" (click)="toHouseType()">
            <!-- 添加房间 -->
            {{ "order.add_house" | translate }}
          </a>
        </div>
      </div>
      <div *ngIf="orderDetail?.out_status === 'cancelled'" class="cancelled-title">
        <!-- 此订单已取消，仅在订单列表可见 -->
        <p>{{ "order.cancel_info" | translate }}</p>
      </div>

      <div
        class="other-houses cursor-pointer"
        *ngIf="isMultiHouseReservation && multiHouseResCollapsed"
        (click)="multiHouseResCollapsed = false">
        <!-- 此订单还有{{
          orderDetail?.reservation_order?.reservation_count - 1
        }}个房间 -->
        {{
          (orderDetail?.reservation_order?.reservation_count > 2
            ? "order.order_has_several_houses_left"
            : "order.order_has_several_house_left"
          )
            | translate
              : {
                  count: orderDetail?.reservation_order?.reservation_count - 1
                }
        }}
        <i nz-icon nzType="down" nzTheme="outline"></i>
      </div>

      <!-- 多入住单房间列表展开 -->
      <div class="house-list" *ngIf="!multiHouseResCollapsed">
        <div class="houses">
          <div
            class="house cursor-pointer v4-layout-list-item flex flex-row items-center justify-between"
            (click)="checkReservation(order?.code)"
            *ngFor="let order of reservationList">
            <div class="house-left">
              <div class="picture">
                <img
                  hostPlaceholder
                  class="rounded-sm"
                  [delaySrc]="(order?.house?.cover | jsonParse)?.small_url"
                  src="/assets/status/placeholder.png"
                  [attr.data-src]="order?.picture" />
              </div>
              <div class="house-detail">
                <div class="house-title">
                  {{ order?.title_alias || order?.house_title || ("word.none" | translate) }}
                </div>
                <div class="house-type-title">
                  <!-- <div *ngIf="order?.house_type_title" class="type-name" [attr.title]="order?.house_type_title">
                    {{ order?.house_type_title }}
                  </div>
                  <span class="time-bar" *ngIf="order?.house_type_title"> | </span> -->
                  <span>
                    {{ order?.check_in | dateformat: ["MD"] }} ~
                    {{ order?.check_out | dateformat: ["MD"] }}
                  </span>
                </div>
              </div>
            </div>
            <div class="house-middle">
              <span>
                {{ order?.currency | currencyToSymbol }}
              </span>
              <span>{{ order?.house_fee }}</span>
              <span class="amount-bar">|</span>
              <span class="whitespace-nowrap">
                {{ "order_status." + order?.out_status | translate }}
              </span>
            </div>
            <!-- <button nz-button class="house-right" (click)="checkReservation(order?.code)">
              查看
              {{ "word.view" | translate }}
            </button> -->
          </div>
        </div>
        <div class="collapse" (click)="multiHouseResCollapsed = true">
          <!-- 收起 -->
          {{ "word.shut" | translate }}
          <i nz-icon nzType="up" nzTheme="outline"></i>
        </div>
      </div>

      <!-- endregion -->

      <!-- alert -->
      <!-- 订单盒子alert -->
      <nz-alert class="mb-3" *ngIf="orderDetail?.in_box" [nzMessage]="boxMsg">
        <ng-template #boxMsg>
          <div class="flex flex-row items-center">
            <img class="w-4 h-4" src="/assets/v4/icon-orderbox.svg" />
            <span class="mx-2">{{ "order.in_orderbox_info" | translate }}</span>
            <a nz-button nzType="link" (click)="toOrderbox()">{{ "word.view" | translate }}</a>
            <i
              class="ml-2"
              nz-icon
              nzType="question-circle"
              nzTheme="outline"
              nz-tooltip
              [nzTooltipTitle]="'order.orderbox_info' | translate"></i>
          </div>
        </ng-template>
      </nz-alert>
      <!-- 冲突单alert -->
      <nz-alert class="mb-3" *ngIf="isConflict" [nzMessage]="conflictMsg">
        <ng-template #conflictMsg>
          <div class="flex flex-row items-center">
            <div class="v4-tag conflict">
              {{ "order.conflict_order" | translate }}
              <!-- Conflicted -->
            </div>
            <span class="mx-2">
              {{ "house_order_detail-basic_html_订单冲突" | translate }}
              <!-- This reservation is conflicted with others. -->
            </span>
            <a nz-button nzType="link" (click)="onClickConflictLink()">
              {{ "word.view" | translate }}
              <!-- View all -->
            </a>
            <i
              class="ml-2"
              nz-icon
              nzType="question-circle"
              nzTheme="outline"
              nz-tooltip
              [nzTooltipTitle]="'order.orderbox_info' | translate"></i>
          </div>
        </ng-template>
      </nz-alert>
      <!-- 小时单alert -->
      <nz-alert class="mb-3" *ngIf="orderDetail?.checkin_last_hour_reservation" [nzMessage]="hourMsg">
        <ng-template #hourMsg>
          <div class="flex flex-row items-center">
            <img class="w-4 h-4" src="/assets/v4/icon-hourorder.svg" alt="" />
            <span class="mx-2">
              {{ orderDetail?.checkin_last_hour_reservation?.text }}
              <!-- Hourly reservations before 15:00 on check-in date. -->
            </span>
            <a
              nz-button
              nzType="link"
              (click)="toHourDetail(orderDetail?.checkin_last_hour_reservation?.reservation_code)">
              {{ "word.view" | translate }}
              <!-- View -->
            </a>
          </div>
        </ng-template>
      </nz-alert>

      <!-- 小时单日历 -->
      <ng-container *ngIf="orderDetail?.hour_reservations.length && orderDetail?.is_hour_reservation">
        <a class="mt-2" nz-button nzType="link" (click)="toggleHourCalendarCollapse()">
          <!-- 展开日历 -->
          {{ (hourCalendarCollapsed ? "order.expand_hour_calendar" : "order.collapse_hour_calendar") | translate }}
          <i nz-icon [nzType]="hourCalendarCollapsed ? 'down' : 'up'" nzTheme="outline"></i>
        </a>
        <div
          class="p-[30px] mb-[30px] bg-[#f7f8fa]"
          *ngIf="orderDetail?.hour_reservations.length && !hourCalendarCollapsed && orderDetail?.is_hour_reservation">
          <host-hour-room-calendar
            [listOfOrder]="orderDetail?.hour_reservations"
            [checkinReservation]="orderDetail?.checkin_reservation"
            [checkoutReservation]="orderDetail?.checkout_reservation"
            [currentReservation]="orderDetail?.code"
            (onDoubleClick)="onClickCreateHourOrder(orderDetail?.check_in)"
            (onReservationClick)="toHourDetail($event)"></host-hour-room-calendar>
          <!-- <a class="mt-2" nz-button nzType="link" (click)="collapseHourCalendar()">
            收起日历
            {{ "order.collapse_hour_calendar" | translate }}
            <i nz-icon nzType="up" nzTheme="outline"></i>
          </a> -->
        </div>
      </ng-container>

      <!-- endregion 4.0 -->

      <div class="info mt-[30px]">
        <ng-container>
          <!-- 入住信息 -->
          <div class="mb-[36px]">
            <host-widget-basic-block
              [isEditing]="isEditingBasicInfo"
              [orderDetail]="orderDetail"
              (onEdit)="editOrderInfo()"
              (onCancelEdit)="cancelEditOrderInfo()"
              (onCompleteEdit)="onModifyBasicInfo()"
              (onLockOrder)="onLockOrder()"
              (onRevokeCheckStatus)="onRevokeCheckStatus()"
              (onClickGuestDetail)="onToGuestPage.emit()"></host-widget-basic-block>
          </div>

          <!-- 费用 -->
          <div class="mb-[36px]">
            <host-widget-fee-block
              [isEditing]="isEditingFee"
              [orderDetail]="orderDetail"
              (onEdit)="onModifyOrderFee()"
              (onCancelEdit)="cancelEditOrderAmount()"
              (onCompleteEdit)="onModifyFee()"
              (onLockOrder)="onLockOrder()"></host-widget-fee-block>
          </div>

          <!-- 入住管理 -->
          <div class="mb-[36px]">
            <host-widget-checkin-block
              [isEditingLockPwd]="isEditingLockPwd"
              [orderDetail]="orderDetail"
              (onEdit)="isEditingLockPwd = true"
              (onCancelEdit)="isEditingLockPwd = false"
              (onCompleteEdit)="onModifyLockPW()"></host-widget-checkin-block>
          </div>

          <!-- 备注 -->
          <div class="v4-layout-info">
            <host-widget-remark
              [reservationCode]="orderDetail?.code"
              [note]="orderDetail?.note"
              (onSuccess)="refreshModal.emit(true)"></host-widget-remark>
          </div>

          <!-- 其他 -->
          <div class="mb-[36px]">
            <host-widget-extra-block
              [orderDetail]="orderDetail"
              (onCompleteEdit)="refreshModal.emit(true)"></host-widget-extra-block>
            <!-- 取消此单 -->
            <div class="v4-layout-field">
              <div class="v4-layout-field-label">
                <a nz-button nzType="link" nzDanger (click)="onClickCancelOrder()">{{
                  "order.cancel_order" | translate
                }}</a>

                <a class="ml-[12px]" nz-button nzType="link" hostClipboard [clipboardData]="resvDetailText">
                  {{ "calendar-order_detail_sidebar-detail_html_copy_detail" | translate }}
                </a>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <!-- 订单详情底部按钮 -->
  <div class="footer flex flex-row justify-between items-center border-t border-solid border-c-gs">
    <ng-container *ngIf="orderStatus !== 'cancelled'; else cancelledOrder">
      <div class="footer-left">
        <div class="button" *ngIf="pageType !== 'sidebar' && orderDetail?.thirdparty_type === 5">
          <button nz-button nzType="default" nzSize="large" (click)="onClickCancelOrder()">
            <!-- 取消此单 -->
            {{ "order.cancel_order" | translate }}
          </button>
        </div>
        <div class="button" *ngIf="pageType === 'sidebar'">
          <button
            nz-button
            nz-dropdown
            nzSize="large"
            [nzDropdownMenu]="createHourOrderMenu"
            [nzPlacement]="'topCenter'">
            <!-- 小时单 -->
            {{ "order.detail_footer_add_hour_order" | translate }}
            <!-- <i nz-icon nzType="caret-down" nzTheme="outline"></i> -->
          </button>
        </div>
      </div>
      <div class="footer-right">
        <!--        接受-拒绝-->
        <ng-container *ngIf="orderStatus === 'wait_accept'">
          <div class="button">
            <button nz-button nzType="primary" nzSize="large" [nzLoading]="acceptLoading" (click)="onAcceptOrder()">
              <!-- 接受 -->
              {{ "order.accept_order" | translate }}
            </button>
          </div>
          <div class="button">
            <button nz-button nzSize="large" [nzLoading]="refuseLoading" (click)="onRejectOrder()">
              <!-- 拒绝 -->
              {{ "order.refuse_order" | translate }}
            </button>
          </div>
        </ng-container>

        <!--        入住/退房-->
        <ng-container *ngIf="['wait_stay', 'staying'].indexOf(orderStatus) !== -1">
          <div class="button">
            <button
              *ngIf="isMultiHouseReservation"
              nz-button
              nzSize="large"
              nz-dropdown
              nzType="primary"
              [nzDropdownMenu]="checkStatusMenu"
              [nzPlacement]="'topCenter'">
              {{
                (orderStatus === "wait_stay"
                  ? "order_detail-house_order_basic_html_入住"
                  : "order_detail-house_order_basic_html_退房"
                ) | translate
              }}
              <!-- <i nz-icon nzType="caret-down" nzTheme="outline"></i> -->
            </button>

            <button
              *ngIf="!isMultiHouseReservation"
              nz-button
              nzType="primary"
              nzSize="large"
              (click)="onUpdateCheckStatus()">
              {{
                (orderStatus === "wait_stay"
                  ? "order_detail-house_order_basic_html_入住"
                  : "order_detail-house_order_basic_html_退房"
                ) | translate
              }}
            </button>
          </div>
        </ng-container>

        <!--        续住-->
        <div class="button">
          <button
            *ngIf="isMultiHouseReservation"
            nz-button
            nzSize="large"
            nz-dropdown
            [nzDropdownMenu]="continueStayMenu"
            [nzPlacement]="'topCenter'">
            <!-- 续住 -->
            {{ "order.continue_stay" | translate }}
            <!-- <i nz-icon nzType="caret-down" nzTheme="outline"></i> -->
          </button>
          <button *ngIf="!isMultiHouseReservation" nz-button nzType="default" nzSize="large" (click)="onExtendStay()">
            {{ "order.continue_stay" | translate }}
          </button>
        </div>

        <!--        关闭-->
        <div *ngIf="pageType === 'sidebar'" class="button">
          <button nz-button nzType="default" nzSize="large" (click)="close()">
            {{ "word.close" | translate }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #cancelledOrder>
      <div class="footer-right">
        <div *ngIf="pageType === 'sidebar'" class="button">
          <button nz-button nzType="default" nzSize="large" (click)="close()">
            {{ "word.close" | translate }}
          </button>
        </div>
      </div>
    </ng-template>
  </div>

  <nz-dropdown-menu #checkStatusMenu="nzDropdownMenu">
    <ul nz-menu class="menu-list">
      <li nz-menu-item (click)="onUpdateCheckStatus()">
        <!-- 入住 -->
        {{ (orderStatus === "wait_stay" ? "order.check_in" : "order.check_out") | translate }}
      </li>
      <li nz-menu-item (click)="onUpdateCheckStatus(true)">
        <!-- 批量入住 -->
        {{ (orderStatus === "wait_stay" ? "order.multi_check_in" : "order.multi_check_out") | translate }}
      </li>
    </ul>
  </nz-dropdown-menu>

  <nz-dropdown-menu #continueStayMenu="nzDropdownMenu">
    <ul nz-menu class="menu-list">
      <li nz-menu-item (click)="onExtendStay()">
        <!-- 续住 -->
        {{ "order.continue_stay" | translate }}
      </li>
      <li nz-menu-item (click)="onExtendStay(true)">
        <!-- 批量续住 -->
        {{ "order.multi_continue_stay" | translate }}
      </li>
    </ul>
  </nz-dropdown-menu>

  <nz-dropdown-menu #createHourOrderMenu="nzDropdownMenu">
    <ul nz-menu class="menu-list">
      <li nz-menu-item (click)="onClickCreateHourOrder(orderDetail?.check_in)">
        {{
          "order.create_hour_order_in_someday"
            | translate
              : {
                  date: orderDetail?.check_in | dateformat: ["MD"]
                }
        }}
      </li>
      <li
        nz-menu-item
        (click)="onClickCreateHourOrder(orderDetail?.check_out)"
        *ngIf="!orderDetail?.is_hour_reservation">
        {{
          "order.create_hour_order_in_someday"
            | translate
              : {
                  date: orderDetail?.check_out | dateformat: ["MD"]
                }
        }}
      </li>
    </ul>
  </nz-dropdown-menu>
</div>
